import { render, staticRenderFns } from "./LoginTemplate.vue?vue&type=template&id=458c9d43&scoped=true&"
import script from "./LoginTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c9d43",
  null
  
)

export default component.exports